import React from 'react';
import ReactPaginate from 'react-paginate';
import styles from './Pagination.module.scss';

type TypePaginationProps = {
	currentPage:number;
	onChangePage:(page:number)=>void;
}

const Pagination: React.FC<TypePaginationProps> = ({ currentPage, onChangePage }) => {
	return (
		<>
			<ReactPaginate
				className={styles.root}
				breakLabel='...'
				nextLabel='>'
				onPageChange={(event) => onChangePage(event.selected + 1)}
				pageRangeDisplayed={4}
				pageCount={3}
				forcePage={currentPage - 1}
				previousLabel='<'
				renderOnZeroPageCount={null}
			/>
		</>
	);
};

export default Pagination;
